<template>
    <div>
        <!-- 交易 -->
        <Echart :options="options" id="bottomLeftChart" height="260px" width="100%"></Echart>
    </div>
</template>

<script>
import Echart from '../../common/echart'
export default {
    data() {
        return {
            options: {},
        };
    },
    components: {
        Echart,
    },
    props: {
        cdata: {
            type: Object,
            default: () => ({})
        },
    },
    watch: {
        cdata: {
            handler(newData) {
                const { category = [], rateData = [] } = JSON.parse(JSON.stringify(newData));
                this.options = {
                    title: {
                        text: '今日分布'
                    },
                    tooltip: {
                        show: "true",
                        trigger: 'item',
                        backgroundColor: 'rgba(0,0,0,0.4)', // 背景
                        padding: [8, 10], //内边距
                        formatter: function (params) {
                            if (params.seriesName != "") {
                                return params.name + ' ：  ' + params.value;
                            }
                        },
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '20%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: category,
                        axisTick: {
                            show: false
                        },

                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.6)',

                            }
                        },
                        axisLabel: {
                            inside: false,
                            interval: 0,//横轴信息全部显示
                            // margin: 50, //刻度标签与轴线之间的距离
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontWeight: 'normal',
                                fontSize: '16',

                            },
                        },
                    },
                    yAxis: {
                        type: 'value',
                        alignTicks: true,
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(255,255,255,0.6)',
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: 'rgba(255,255,255,0.6)',
                                fontWeight: 'normal',
                                fontSize: '12',

                            },
                        },
                    },
                    series: [
                        {
                            data: rateData,
                            type: 'bar',
                            zlevel: 2,
                            barWidth: '40%',
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color: "rgba(90, 216, 166, 1)",
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: '11',
                                        color: 'white',

                                    },
                                    barBorderRadius: [8, 8, 0, 0],
                                    borderWidth: 0,
                                },
                                emphasis: {
                                    shadowBlur: 15,
                                    shadowColor: 'rgba(105,123, 214, 0.7)'
                                }
                            },
                        }
                    ]
                }
            },
            immediate: true,
            deep: true
        },
    },
}
</script>